export const GiftCardBig = () => (
  <svg
    width="72"
    height="59"
    viewBox="0 0 72 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="elements">
      <path
        id="Vector"
        d="M2.83105 23.3364C2.83105 13.9587 2.83105 9.2699 5.74432 6.35663C8.65759 3.44336 13.3464 3.44336 22.7241 3.44336H49.2482C58.6258 3.44336 63.3147 3.44336 66.228 6.35663C69.1412 9.2699 69.1412 13.9587 69.1412 23.3364V36.5984C69.1412 45.9761 69.1412 50.665 66.228 53.5782C63.3147 56.4915 58.6258 56.4915 49.2482 56.4915H22.7241C13.3464 56.4915 8.65759 56.4915 5.74432 53.5782C2.83105 50.665 2.83105 45.9761 2.83105 36.5984V23.3364Z"
        stroke="#009C8F"
        strokeWidth="4.97326"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M16.0933 23.0188C16.0933 7.95173 35.9863 23.3034 35.9863 33.2826H24.382C18.6237 33.2826 16.0933 28.2095 16.0933 23.0188Z"
        stroke="#009C8F"
        strokeWidth="4.97326"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M55.8794 23.0188C55.8794 7.95172 35.9863 23.3034 35.9863 33.2826H47.5906C53.349 33.2826 55.8794 28.2095 55.8794 23.0188Z"
        stroke="#009C8F"
        strokeWidth="4.97326"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M35.9863 3.44336V56.4915"
        stroke="#009C8F"
        strokeWidth="4.97326"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M2.83105 33.2832H69.1412"
        stroke="#009C8F"
        strokeWidth="4.97326"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_6"
        d="M45.9326 43.2297L35.9861 33.2832L26.0396 43.2297"
        stroke="#009C8F"
        strokeWidth="4.97326"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
